var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ComplexBase } from '@syncfusion/ej2-react-base';
var StackedColumnDirective = /** @class */ (function (_super) {
    __extends(StackedColumnDirective, _super);
    function StackedColumnDirective() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StackedColumnDirective.moduleName = 'stackedColumn';
    StackedColumnDirective.complexTemplate = { 'filterItemTemplate': 'filter.itemTemplate' };
    return StackedColumnDirective;
}(ComplexBase));
export { StackedColumnDirective };
var StackedColumnsDirective = /** @class */ (function (_super) {
    __extends(StackedColumnsDirective, _super);
    function StackedColumnsDirective() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StackedColumnsDirective.propertyName = 'columns';
    StackedColumnsDirective.moduleName = 'stackedColumns';
    return StackedColumnsDirective;
}(ComplexBase));
export { StackedColumnsDirective };
